/**
 * Un si/no importante, del ancho de su contenedor, que se lee de lejos: el
 * estado va escrito ("Activo"/"Apagado") y cambia el color de toda la caja,
 * no solo la pastilla. Para decisiones que cambian lo que ve el cliente
 * (ofrecer retiro, despachar a una region), donde una casilla pasa inadvertida.
 */
import { Icono } from '../comunes/Icono';

interface InterruptorGrandeProps {
  encendido: boolean;
  titulo: string;
  detalleEncendido: string;
  detalleApagado: string;
  deshabilitado?: boolean;
  alCambiar: (encendido: boolean) => void;
}

export function InterruptorGrande({
  encendido,
  titulo,
  detalleEncendido,
  detalleApagado,
  deshabilitado = false,
  alCambiar,
}: InterruptorGrandeProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={encendido}
      className={encendido ? 'interruptor-grande on' : 'interruptor-grande'}
      disabled={deshabilitado}
      onClick={() => {
        alCambiar(!encendido);
      }}
    >
      <span className="interruptor-grande-texto">
        <span className="interruptor-grande-titulo">{titulo}</span>
        <span className="interruptor-grande-detalle">
          {encendido ? detalleEncendido : detalleApagado}
        </span>
      </span>
      <span className="interruptor-grande-estado">
        <Icono nombre={encendido ? 'checkCirc' : 'cerrar'} />
        {encendido ? 'Activo' : 'Apagado'}
      </span>
      <span className={encendido ? 'interruptor on' : 'interruptor'} aria-hidden="true" />
    </button>
  );
}
